export default {
	data() {
		return {
			sectionIndex: 0, // current section index
			scrollContainer: null, //scroll section DOM container element
			scrollContainerSelector: '.scroll-container',
			scrollWindowSelector: '.scroll-container-window',
			enterCbName: undefined,
			leaveCbName: undefined,
			beforeMoveCb: undefined,
			inhibitScrollSources: { up: {}, down: {} },
		}
	},
	computed: {
		currSection() {
			// let rtn = this.sections.length ? this.sections[this.sectionIndex] : undefined;
			return this.sections[this.sectionIndex];
		},
		currStepIndex() {
			return this.currSection.stepIndex;
		},
		currSectionNumSteps() {
			return this.currSection.numSteps;
		},
		numSections() {
			return this.sections.length;
		},
		inhibitScroll() {
			return {
				up: Object.values(this.inhibitScrollSources.up).length && (Object.values(this.inhibitScrollSources.up).find(n => n != true) || true),
				down: Object.values(this.inhibitScrollSources.down).length && (Object.values(this.inhibitScrollSources.down).find(n => n != true) || true),
			};
		},
	},
	methods: {
		scrollEventHandler(direction) {
			switch (direction) {
				case 'up':

					this.enterCbName = 'enterBackCb';
					this.leaveCbName = 'leaveBackCb';					

					if (this.currStepIndex == 0) {
						if (this.sectionIndex == 0) {
							break;
						} else {
							this.changeSection(this.sectionIndex - 1);
						}
					} else {
						this.changeStep(this.currSection, this.currStepIndex - 1);
					}

					break;

				case 'down':

					this.enterCbName = 'enterCb';
					this.leaveCbName = 'leaveCb';

					if (this.currStepIndex == this.currSectionNumSteps - 1) {
						if (this.sectionIndex == this.numSections - 1) {
							break;
						} else {
							this.changeSection(this.sectionIndex + 1);
						}
					} else {
						this.changeStep(this.currSection, this.currStepIndex + 1);
					}

					break;

				default:
					break;
			}
		},
		inhibitScrollContainer(name, val) {
			if (val.up && !this.inhibitScrollSources.up[name]) {
				this.inhibitScrollSources.up[name] = val.up;
			} else if (!val.up) {
				delete this.inhibitScrollSources.up[name];
			}
			
			if (val.down && !this.inhibitScrollSources.down[name]) {
				this.inhibitScrollSources.down[name] = val.down;
			} else if (!val.down) {
				delete this.inhibitScrollSources.down[name];
			}
		},
		resetInhibitScroll() {
			this.inhibitScrollContainer('_manual', { up: false, down: false });
		},
		setInhibitScroll() {
			this.inhibitScrollContainer('_manual', { up: true, down: true });
		},
		changeSection(index, cb) {
			// store previous and next sections
			const prevSection = this.sections[this.sectionIndex];
			const nextSection = this.sections[index];

			// actually "scroll" to next section


			let areAdjacent = Math.abs(this.sectionIndex - index) == 1;
			let dontMove = (prevSection.isFixed || nextSection.isFixed) && areAdjacent;
			
			let direction = index > this.sectionIndex ? 'down' : 'up'
			if (direction == 'down') {
				this.enterCbName = 'enterCb';
				this.leaveCbName = 'leaveCb';
			}
			if (direction == 'up') {
				this.enterCbName = areAdjacent ? 'enterBackCb' : 'enterCb';
				this.leaveCbName = 'leaveBackCb';
			}

			this.sectionIndex = index;

			let callCallbacks = (fixedOnly) => {

				if(cb) cb()
				
				this.inhibitScrollContainer('_change', {up: false, down: false});
				if (nextSection[this.enterCbName] && (fixedOnly !== true || nextSection.isFixed)) {
					nextSection[this.enterCbName]();
				}
				if (prevSection[this.leaveCbName] && (fixedOnly !== true || prevSection.isFixed)) {
					prevSection[this.leaveCbName]();
				}
				

				// this.scrollTransitionEnd();				
			}
			if(!dontMove) {
				const totalOffset = this.sections.filter((el, i) => i < this.sectionIndex).reduce((a, b) => a + (b.offset || 0), 0);
				// (async () => {
					// if(this.beforeMoveCb) {
					// 	await this.beforeMoveCb(direction);
					// }

					window.requestAnimationFrame(() => {
						// @FIXME: 100vh is not the screen size on iPads...
						let newAmount = (100 * - (this.sectionIndex - this.sections.filter((el, i) => (i < this.sectionIndex) && el.isFixed).length)) - totalOffset + 'vh';
						this.scrollContainer.style.transform = `translateY(${newAmount})`;	
					});
				// })()
				// inhibit scroll gestures until the transition is over
				this.inhibitScrollContainer('_change', {up: true, down: true});
				this.scrollContainer.addEventListener('transitionend', () => {
					callCallbacks()//(nextSection.isFixed)
				}, {once: true}) 
			}else {
				
				if (!cb) {
					window.addEventListener("introfolded", ()=>{
						callCallbacks();
					}, {once: true})
				}
				callCallbacks(true);
			}				
		},
		changeStep(section, index) {
			const prevStep = section.steps && section.steps[section.stepIndex] ? section.steps[section.stepIndex] : undefined;
			const nextStep = section.steps && section.steps[index] ? section.steps[index] : undefined;

			section.stepIndex = index;

			if (nextStep && nextStep[this.enterCbName]) nextStep[this.enterCbName]();
			if (prevStep && prevStep[this.leaveCbName]) prevStep[this.leaveCbName]();
		},
		initSections() {
			Array.from(document.querySelectorAll(this.scrollContainerSelector + ' > section')).forEach((section, i) => {
				let spec = this.sections.find(el => el.id == section.id);
				spec.el = section;
				spec.stepIndex = 0;
			});
			this.scrollContainer = document.querySelector(this.scrollContainerSelector);
			document.querySelector(this.scrollWindowSelector).style.height = window.innerHeight+'px';			
		},
		getSectionById(id) {
			return this.sections.find( el => el.id == id);
		},
		goToSection(index, cb) {
			this.changeSection(parseInt(index - 1), cb);
		},
		initFinalSection() {
			
		},
		resizeCallback() {
			document.querySelector(this.scrollWindowSelector).style.height = window.innerHeight+'px';
		},
	},
	mounted () {
		// this.initSections();
		window.addEventListener('resize', this.resizeCallback)
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.resizeCallback)
	}
}
